const getTabsOverflowState = (tabs) =>
  Boolean(tabs && tabs.scrollWidth > tabs.clientWidth + 1);

const updateDashboardTabsOverflow = (root = document) => {
  if (typeof document === 'undefined') return;

  root
    .querySelectorAll?.('.dashboard-tabs-shell, .template-dashboard-tabs-header')
    .forEach((shell) => {
      const tabs = shell.querySelector('.dashboard-tabs');
      shell.classList.toggle('dashboard-tabs-overflowing', getTabsOverflowState(tabs));
    });
};

const startDashboardTabsOverflowWatcher = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__samaDashboardTabsOverflowWatcher) return;

  window.__samaDashboardTabsOverflowWatcher = true;

  const scheduleUpdate = () => {
    window.requestAnimationFrame(() => updateDashboardTabsOverflow(document));
  };

  scheduleUpdate();
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);

  if (typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    const observeTabs = () => {
      document.querySelectorAll('.dashboard-tabs').forEach((tabs) => {
        resizeObserver.observe(tabs);
      });
    };
    observeTabs();

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(() => {
        observeTabs();
        scheduleUpdate();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  } else if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, { childList: true, subtree: true });
  }
};

startDashboardTabsOverflowWatcher();

export const scrollDashboardTabs = (event, direction = 1) => {
  const shell = event.currentTarget.closest('.dashboard-tabs-shell, .template-dashboard-tabs-header');
  const tabs = shell?.querySelector('.dashboard-tabs');

  if (!tabs) return;

  const amount = Math.max(220, Math.round(tabs.clientWidth * 0.65));
  tabs.scrollBy({
    left: amount * direction,
    behavior: 'smooth',
  });
  window.requestAnimationFrame(() => updateDashboardTabsOverflow(shell));
};
